import React from 'react';

const CinemasListSkeleton: React.FC = () => {
    return (
        <div className="flex flex-col space-y-12 px-12">
            {[...Array(3)].map((_, rowIndex) => (
                <div
                    className="py-12 flex flex-col space-y-12"
                    key={rowIndex}>
                    <div className="flex flex-row space-x-12">
                        <div className="w-42 h-42 bg-[rgba(var(--on-non-transparent-surface-color-rgb),0.2)] rounded-full animate-pulse"></div>
                        <div className="flex flex-col space-y-4">
                            <div className="h-[20px] w-[100px] bg-[rgba(var(--on-non-transparent-surface-color-rgb),0.2)] rounded-4 animate-pulse" />
                            <div className="h-[14px] w-[200px] bg-[rgba(var(--on-non-transparent-surface-color-rgb),0.2)] rounded-4 animate-pulse" />
                        </div>
                    </div>
                    <div className="flex flex-row gap-8 flex-wrap">
                        {[...Array(5)].map((_, index) => (
                            <div
                                key={rowIndex + '-' + index}
                                className="h-[48px] w-[80px] bg-[rgba(var(--on-non-transparent-surface-color-rgb),0.2)] rounded-4 animate-pulse"
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CinemasListSkeleton;
